import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../common/shared/services/auth.service';
import { UtilitiesService } from '../../../common/shared/services/utilities.service';
import { ChangePasswordCredentials } from '../../../common/models/change-password-credentials';
import * as zxcvbn from 'zxcvbn';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  changePasswordCredentials: ChangePasswordCredentials;
  hidePW = true;

  passwordStrength = 0;
  passwordRegEx = '';

  constructor(
    private _dialogRef: MatDialogRef<ChangePasswordComponent>,
    private _authService: AuthService,
    private _utilitiesService: UtilitiesService) {
      this.passwordRegEx = _utilitiesService.passwordRegEx;
    }

  ngOnInit() {
    this.changePasswordCredentials = new ChangePasswordCredentials();
  }

  update() {
    this._utilitiesService.addMinorAction('ChangePassword');
    this._authService.changePassword(this.changePasswordCredentials).subscribe(
      data => {
        this._utilitiesService.removeAction('ChangePassword');
        if (this._utilitiesService.getData(data)) {
          this._dialogRef.close('Success');
        } else {
          this._dialogRef.close('Error');
        }
      },
      err => {
        this._utilitiesService.handleErrors(err);
        this._dialogRef.close('Error');
      }
    );
  }

  updateActionActive() {
    return this._utilitiesService.isActionActive('ChangePassword');
  }

  updatePasswordStrength(): void {
    const results = zxcvbn(this.changePasswordCredentials.newPassword);
    this.passwordStrength = results.score;
  }

}
